import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    rolePermissions: [],
};

const permissionSlice = createSlice({
    name: "rolePermissions",
    initialState,
    reducers: {
        addPermission: (state, action) => {
            state.rolePermissions = action.payload;
        },
    },
});
export const {
    addPermission
} = permissionSlice.actions;
export default permissionSlice.reducer;
